import angular from 'angular';
import subscriptionsConfig from './subscriptions.config';

import subscriptions from '../../containers/subscriptions';

const subscriptionsModule = angular.module('meredicte.subscriptions', [])
  .component('appSubscriptions', subscriptions)
  .config(subscriptionsConfig);

export default subscriptionsModule;



// WEBPACK FOOTER //
// ./src/modules/subscriptions/subscriptions.module.js